export default __webpack_public_path__ + "static/media/banner_boardingBridge.482a0e34.svg";